import type {
  APILibraryCategoryRequestType,
  APILibraryCategoryResponseType,
} from "@/core/data_sources/models/APILibraryCategory";
import type { BasicQuery } from "@/core/data_sources/services";
import { del, get, patch, post } from "@/core/utils/request";

export function getCategories<Q extends BasicQuery>(query: Q) {
  void query;
  return get<APILibraryCategoryResponseType[]>("/library/categories/", {
    params: query,
  });
}
export function getCategoryById(id: number) {
  return get<APILibraryCategoryResponseType>(`/library/categories/${id}/`);
}
export function postCategory(data: APILibraryCategoryRequestType) {
  return post<APILibraryCategoryRequestType, APILibraryCategoryResponseType>(
    "/library/categories/",
    data,
  );
}
export function patchCategory(id: number, data: APILibraryCategoryRequestType) {
  return patch<
    Partial<APILibraryCategoryRequestType>,
    APILibraryCategoryResponseType
  >(`/library/categories/${id}/`, data);
}
export function deleteCategory(id: number) {
  return del(`/library/categories/${id}/`);
}
